export default {"src":"/_next/static/media/nieuwbouw.ad6e9623.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};